import React, { useState, useEffect } from "react";
import { Button, Select, Spin } from "antd";
import { createSubProjectType, getAllSubProjectTypes, updateException } from "../api"; 
import { message } from "antd";
import { ExceptionStatus } from "../ExceptionDrawer";
import Hide from "../../components/Hide";

const { Option } = Select;

const SubProjectTypeComponent = ({ exception, onClose, onResolved }) => {
    const [subProjectTypeName, setSubProjectTypeName] = useState(null);
    const [subProjectTypeDescription, setSubProjectTypeDescription] = useState(null);
    const [showSelect, setShowSelect] = useState(false);
    const [subProjectTypes, setSubProjectTypes] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (exception) {
            setSubProjectTypeName(exception?.unknown_infomation); 
            setSubProjectTypeDescription(exception?.description); 
        }

        const fetchSubProjectTypes = async () => {
            setLoading(true); 
            try {
                const subProjectTypesAll = (await getAllSubProjectTypes()).data;
                console.log(subProjectTypesAll);
                setSubProjectTypes(Array.isArray(subProjectTypesAll) ? subProjectTypesAll : []);
            } catch (error) {
                console.error("Failed to fetch sub-project types", error);
            } finally {
                setLoading(false); 
            }
        };

        fetchSubProjectTypes();
    }, [exception]);

    const handleMarkAsNew = async () => {
        if (subProjectTypeName && subProjectTypeDescription) {
            setLoading(true); 
            try {
                await createSubProjectType({
                    name: subProjectTypeName,
                    unit_id: 1,
                    description: 'HardCoded description'
                });
                await updateException(exception.id);
                console.log(`Sub Project Type "${subProjectTypeName}" created successfully.`);
                message.success('Sub-project type created');
                try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                onClose();
            } catch (error) {
                console.error(`Failed to create sub-project type "${subProjectTypeName}".`, error);
                message.error('Failed to create sub-project type');
                try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                onClose();
            } finally {
                setLoading(false); 
            }
        } else {
            console.warn("Incomplete sub-project type details.");
            onClose();
        }
    };

    const handleMarkAsAliasFor = () => {
        setShowSelect(true);
    };

    const [selectedAliasId, setSelectedAliasId] = useState(null);
    const handleSubProjectTypeSelect = (value) => {
        setSelectedAliasId(value ?? null);
    };

    const handleSaveAlias = async () => {
        if (!selectedAliasId) return;
        if (exception.status === 'pending') {
            setLoading(true);
            try {
                await createSubProjectType({
                    name: subProjectTypeName,
                    alias_for: selectedAliasId,
                    unit_id: 1,
                    description: 'HardCoded description'
                });
                await updateException(exception.id);
                console.log(`Sub Project Type "${subProjectTypeName}" set as alias for sub-project type with ID: ${selectedAliasId}`);
                message.success('Alias saved');
                try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                onClose();
            } catch (error) {
                console.error(`Failed to update alias for sub-project type with ID: ${selectedAliasId}`, error);
                message.error('Failed to save alias');
                try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                onClose();
            } finally {
                setLoading(false);
            }
        } else {
            console.warn("Exception already resolved.");
            onClose();
        }
    };


    return (
        <div style={{ marginTop: 20 }}>
            <Hide condition={exception.status === ExceptionStatus.RESOLVED}>
                <Spin spinning={loading} tip="Processing...">
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                        <Button 
                            type="primary" 
                            onClick={handleMarkAsNew}
                            disabled={loading}
                            loading={loading}
                        >
                            Mark as New
                        </Button>
                        <Button 
                            type="default" 
                            onClick={handleMarkAsAliasFor}
                            disabled={loading}
                        >
                            Mark as Alias For
                        </Button>
                        {showSelect && (
                            <>
                                <div style={{ fontSize: 12, color: '#666' }}>
                                    {subProjectTypeName ? `Select an existing sub-project type to alias "${subProjectTypeName}" to.` : 'Select an existing sub-project type to alias.'}
                                </div>
                                <Select
                                    style={{ minWidth: 240 }}
                                    placeholder="Select a sub-project type"
                                    onChange={handleSubProjectTypeSelect}
                                    value={selectedAliasId ?? undefined}
                                    disabled={loading}
                                >
                                    {subProjectTypes?.map((subProjectType) => (
                                        <Option key={subProjectType.id} value={subProjectType.id}>
                                            {subProjectType.name}
                                        </Option>
                                    ))}
                                </Select>
                                <Button
                                    type="primary"
                                    onClick={handleSaveAlias}
                                    disabled={loading || !selectedAliasId}
                                    loading={loading}
                                >
                                    Save
                                </Button>
                            </>
                        )}
                    </div>
                </Spin>
            </Hide>
        </div>
    );
};

export default SubProjectTypeComponent;
